<template>
  <main id="app" class="fade-in">
    <app-navbar/>
    <app-jumbotron/>
    <div class="container">

      <div class="row">
        <app-card :classes="['col-lg-10', 'col-xl-8', 'ml-auto', 'Card-wrapper--jumbo']">
          <h3 class="Card-title" slot="Card-title">
            Multitouch Rentals
          </h3>
          <p slot="Card-body">
            Ideum rents its high-quality multitouch tables and touch displays directly to you. Our products’ clean, beautiful designs and durable construction will help you stand out, whether you are renting for a trade show, an exhibit, or another special event.
          </p>
        </app-card>
      </div>

      <app-products/>

      <div class="row">
        <app-card :classes="['mr-auto', 'col-lg-10', 'col-xl-8', 'Reveal']" style="margin-top: 8em;">
          <h3 class="Card-title" slot="Card-title">Turnkey Solutions</h3>
          <p slot="Card-body">
            Ideum has been developing integrated multitouch systems for a decade. Our touch tables are found at the busiest public spaces in the world, including the Smithsonian Air and Space Museum in Washington, D.C. Our systems are made from aircraft grade aluminum and we use the latest and most reliable technology. And they are easy to set up—no technicians or assembly is required. If support is needed, we have a dedicated support line, and the same people who built our touch tables provide our timely support.
          </p>
        </app-card>
      </div>

    </div>

    <app-product-tips/>

    <app-story/>

    <app-creative-services/>

    <app-contact/>

    <app-footer/>

  </main>
</template>

<script>
import appCard from './components/Card'
import appJumbotron from './components/Jumbotron'
import appNavbar from './components/Navbar'
import appProducts from './components/Products'
import appProductTips from './components/Product-tips'
import appStory from './components/Story'
import appCreativeServices from './components/CreativeServices'
import appContact from './components/Contact'
import appFooter from './components/Footer'
require('lazysizes')
const ScrollReveal = require('scrollreveal')
export default {
  name: 'app',

  components: {
    appCard,
    appJumbotron,
    appNavbar,
    appProducts,
    appProductTips,
    appStory,
    appCreativeServices,
    appContact,
    appFooter
  },

  mounted () {
    window.sr = ScrollReveal({
      duration: 1000,
      scale: 1
    })
    window.sr.reveal('.Reveal')
    window.sr.reveal('.Reveal--right', {
      delay: 500
    })
    window.sr.reveal('.Reveal--left', {
      origin: 'left'
    })
    window.sr.reveal('.Reveal--sequenced', {
      delay: 250,
      distance: '10vh'
    }, 250)
    window.sr.reveal('.Reveal--sequenced--right', {
      delay: 250,
      origin: 'right'
    }, 250)
  }
}
</script>

<style lang="scss" scoped>
#app {
  overflow: hidden;
}
</style>




// WEBPACK FOOTER //
// src/App.vue